import AxiosControl from '../../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getReservationPublicByCourtAndDate = (court, date) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        const { data, status } = await Axios.get(`/api/reservation/public/getreservationpublicbycourtanddate?court=${court}&date=${date}`)
        if (status === 200) {
            dispatch({
                type: 'RESERVATION_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}

export const rentCourt = (reservationData, force = null) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/reservation/register', {reservationData, force}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'RESERVATION_ADD_SUCCESS',
                payload: data
            })
        }else{
            if(status === 201){
                dispatch({
                    type: 'RESERVATION_ADD_NOT_SUCCESS',
                    payload: data
                })
            }
        }
    } catch (error) {
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}

export const getReservationsByClubAndDate = (club, date) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        // Add a small delay to ensure stability
        await new Promise(resolve => setTimeout(resolve, 500));
        
        const { data, status } = await Axios.get(`/api/reservation/getreservationsbyclubanddate?club=${club}&date=${date}`)
        if (status === 200) {
            dispatch({
                type: 'RESERVATION_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        console.error('Error fetching reservations:', error);
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}

export const getReservationsCanceledByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        const { data, status } = await Axios.get(`/api/reservation/getreservationscanceledbyclub?club=${club}`)
        if (status === 200) {
            dispatch({
                type: 'RESERVATION_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}

export const getReservationsByClient = (client) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/reservation/getreservationsbyclient/' + client, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'RESERVATION_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}

export const cancelReservation = (reservationId, multiple) => async (dispatch) => {
    try {
        dispatch({ type: 'RESERVATION_CANCEL_REQUEST' })

        const jwt = sessionStorage.getItem('jwt');
        const tempToken = sessionStorage.getItem('temp_cancel_token');
        
        const headers = {};
        if (jwt) {
            headers['auth'] = jwt;
        } else if (tempToken) {
            headers['temp-token'] = tempToken;
        }

        const { data } = await AxiosControl().post('/api/reservation/cancelreservation/' + reservationId, {
            multiple: multiple
        }, { headers });

        dispatch({
            type: 'RESERVATION_CANCEL_SUCCESS',
            payload: data
        })

        // Limpiar el token temporal después de usarlo
        if (tempToken) {
            sessionStorage.removeItem('temp_cancel_token');
        }

    } catch (error) {
        dispatch({
            type: 'RESERVATION_CANCEL_FAIL',
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        })
    }
}